import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HamburgerMenuHeader from "../../Header/DeliveryMenuHeader";

import DeliveryThumbnail from "../../../assets/images/delivery-thumbnail.png";
import { useTranslation } from "react-i18next";

const DeliveryHowToUse = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const deliveryVideo =
    "https://tmw-storage.s3.ap-south-1.amazonaws.com/TMW-Kiosk/tmw_multimedia_assets/videos/Delivery+Manual+Final_C.mp4";

  return (
    <>
      <HamburgerMenuHeader title={t("howToUse", "How To Use")} />
      {/* Main Section */}
      <section className="w-full max-w-[1920px] mx-auto bg-white px-4 sm:px-6 md:px-8 py-6">
        <div className="w-full max-w-[1211.62px] mx-auto flex flex-col">
          {/* Responsive Title Container – 35px above video */}
          <div className="mt-[35px] w-full flex justify-center">
            <div
              className="
                w-[776px] h-[55px] flex items-center justify-center
                text-center capitalize
                text-[32px] sm:text-[36px] md:text-[40px]
                leading-[100%] tracking-[0%]
                font-alata font-normal
              "
            >
              How To Deliver The Parcel?
            </div>
          </div>

          {/* Video */}
          <div className="mt-6 w-full">
            <video
              controls
              className="w-full max-h-[672.11px] object-cover rounded-lg shadow-lg"
              poster={DeliveryThumbnail}
              preload="metadata"
            >
              <source src={deliveryVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeliveryHowToUse;
